<span class="loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bardashboard></app-side-menu-bardashboard>
<div class="main-content">
    <!-- <div class="heading">
        <label class="heading-text">DPI Reduction Report</label>
    </div> -->
    <div class="filters" [formGroup]="dpiAnalysisForm">
        <!-- <div class="filtersDropdownS">
          <mat-form-field appearance="fill" class="datepickerwidth">
            <mat-label>Semester</mat-label>
            <mat-select formControlName="YearlyControl" (selectionChange)="clearData()">
              <mat-option *ngFor="let yearly of yearlySelect" [value]="yearly">{{yearly}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        <div class="filtersDropdownS">
          <mat-form-field appearance="fill" class="datepickerwidth">
            <mat-label>Year</mat-label>
            <mat-select formControlName="YearControl" (selectionChange)="clearData()">
              <mat-option *ngFor="let year of yearSelect" [value]="year">{{year}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Cluster -->
        <div class="filtersDropdown">
          <mat-form-field appearance="fill" class="datepickerwidth">
            <mat-label>Select BU/GBU Sub-Region</mat-label>
            <mat-select #clusterControl [(ngModel)]="clusterdefault"  formControlName="clusters"  (selectionChange)="loadSite()">
              <!-- <div class="select-all">
                <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}"
                  (change)="toggleAllSelection()">Select All</mat-checkbox>
              </div> -->
              <mat-option *ngFor="let clus of cluster" (click)="optionClick()" [disabled]="disableCluster" [value]="clus">
                {{clus}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Site -->
        <div class="filtersDropdown">
          <mat-form-field appearance="fill" class="datepickerwidth">
            <mat-label>Select Site</mat-label>
            <mat-select #siteControl [(ngModel)]="sitedefault" formControlName="sites"  (selectionChange)="loadBigCategory()">
              <!-- <div class="select-all">
                <mat-checkbox [(ngModel)]="siteAllSelected" [ngModelOptions]="{standalone: true}"
                  (change)="toggleSiteAllSelection()">Select All</mat-checkbox>
              </div> -->
              <mat-option *ngFor="let fact of site" (click)="optionsiteClick()" [disabled]="disableSite" [value]="fact">
                {{fact}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Big Category -->
        <div class="filtersDropdown">
          <mat-form-field appearance="fill" class="datepickerwidth">
            <mat-label>Select Business Group</mat-label>
            <mat-select #bigCategoryControl [(ngModel)]="bigcategorydefault"
               formControlName="bigcategories" multiple
               (selectionChange)="clearData()">
              <mat-option *ngFor="let categ of bigcategory" (click)="optionBigCategoryClick()" [value]="categ">{{categ}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="filtersDropdown">
          <button class="btn-qm" color="primary" (click)="generateReport()">
            Generate Report
          </button>
        </div>
        <div class="alert alert-danger failMsg" *ngIf="showValidationMessage">
          {{ValidationMsg}}
        </div>
        <div class="alert alert-success failMsg" *ngIf="showSuccess">
          {{recordsinserteddetails}} <br />
          {{recordupdateddetails}}
        </div>
    </div>
    <div *ngIf="!nofiltereddata" class="centerHeaderCell">
      <h4>DPI Reduction for Top Losses</h4>
    </div>
    <div [ngClass]="isAuthorized ? 'initialPosition' : 'pushedfromUp'">
        <div *ngIf="nofiltereddata" class="records">{{noRecords}}</div>
        <div class="dpiAnalysis-container mat-elevation-z8" [hidden]="nofiltereddata" [ngClass]="isAuthorized ? '' : 'newHeight'">
          <mat-paginator #paginator 
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons>
          </mat-paginator>
          <table mat-table [dataSource]="dataSource" [hidden]="nofiltereddata">
            <!-- LossTree Column -->
            <ng-container matColumnDef="Loss Tree">
              <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Loss Tree </th>
              <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.defectmodeaggregation}} </td>
            </ng-container>
             <!-- Lelel 0 Column -->
             <ng-container matColumnDef="Level0">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Level 0 </th>
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.level0}} </td>
            </ng-container>
            
            
            <!-- H2 DPI Column -->
            <ng-container matColumnDef="GroupOneDPI">
                <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> DPI <br/> (Not Started, Plan, Do) </th>
                <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.groupone | number}} </td>
              </ng-container>
            <!-- Logged PDCA Status Column -->
            <ng-container matColumnDef="GroupTwoDPI">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> DPI  <br/> (Check, Act, Done) </th>
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.grouptwo | number}} </td>
            </ng-container>
           
            <!-- DPI Reduction Percentage Column -->
            <ng-container matColumnDef="DPI Reduction Percentage">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> DPI Reduction % </th>
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.dpireductionpercentage}} </td>
            </ng-container>    
            <tr mat-header-row *matHeaderRowDef="DpiReductionCols; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: DpiReductionCols;"></tr>
          </table>
        </div>
        <div class="dpiAnalysis-container mat-elevation-z8" [hidden]="nofiltereddata" [ngClass]="isAuthorized ? '' : 'newHeight'">
         
          <table mat-table [dataSource]="OverallDpiDataSource" [hidden]="nofiltereddata">
            <!-- LossTree Column -->
            <ng-container matColumnDef="Loss Tree">
              <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.defectmodeaggregation}} </td>
            </ng-container>
             <!-- Lelel 0 Column -->
             <ng-container matColumnDef="Level0">
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.level0}} </td>
            </ng-container>
            
            
            <!-- H2 DPI Column -->
            <ng-container matColumnDef="GroupOneDPI">
                <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.groupone }} </td>
              </ng-container>
            <!-- Logged PDCA Status Column -->
            <ng-container matColumnDef="GroupTwoDPI">
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.grouptwo }} </td>
            </ng-container>
           
            <!-- DPI Reduction Percentage Column -->
            <ng-container matColumnDef="DPI Reduction Percentage">
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.dpireductionpercentage}} </td>
            </ng-container>    
            <tr mat-row *matRowDef="let row; columns: DpiReductionCols;"></tr>
          </table>
        </div>
    </div>
</div>
